import { render, staticRenderFns } from "./ArticleInfo.vue?vue&type=template&id=08e05b45&"
import script from "./ArticleInfo.vue?vue&type=script&lang=js&"
export * from "./ArticleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports